<template>
	<form name="form" method="post" :action="url" ref="form">
		<input type="hidden" name="DO" :value="token" />
	</form>
</template>

<script>
export default {
	props: {
		url: { type: String, required: true, default: "" },
		token: { type: String, required: true, default: "" }
	},

	mounted() {
		this.$refs.form.submit()
	}
}
</script>